import { render } from "./StepsCompetenceDimensions.vue?vue&type=template&id=0c09d450"
import script from "./StepsCompetenceDimensions.vue?vue&type=script&lang=js"
export * from "./StepsCompetenceDimensions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__